module.exports = __webpack_public_path__ + "static/media/chat.dba318df.svg";